import styles from "./table.module.css";

export default function TableContainer({ children }) {
return(
  <table className={styles.table}>
    {children}
  </table>)
}